import qs from 'qs';

interface QueryParams {
    designerId?: number;
    category?: string;
    package?: string;
    platform?: string;
}

export const parseQueryString = (query: string): QueryParams => {
    // react router includes the `?` in the query string, which qs adds to the first key name.
    // eslint-disable-next-line eqeqeq
    if (query[0] == '?') {
        query = query.slice(1);
    }
    const { designerId, category, package: pkg, platform } = qs.parse(query);
    return {
        designerId: designerId ? parseInt(designerId as string) : undefined,
        category: category as string,
        package: pkg as string,
        platform: platform as string,
    };
};
